import React, { PropsWithChildren, useEffect, useState, useCallback } from 'react'
import clsx from 'clsx'
import { Button, Layout, Dropdown, Menu } from 'antd'
import { CaretDownOutlined } from '@ant-design/icons'
import {
  logout,
  spiderLogout,
  changeAccount,
  getManageAccount,
  getWechatKanBanSenceQrCode,
  Account
} from '@/services/mendian'
import styles from './header.module.less'
import { getLoginInfo } from '@/services/api'
import { USE_NEW_LAYOUT_COOKIE, Y, N, NEW_LAYOUT_COOKIE_AGE } from '@/constant'
import { getCookie, setCookie } from '@/utils/cookie'
import { QRCodeDropdown } from '@/components/layout/mendian/header/qrcode-dropdown'

const useManageAccounts = () => {
  const [companyId, setCompanyId] = useState<number>()
  const [accounts, setAccounts] = useState<Account[]>([])

  useEffect(() => {
    getManageAccount().then((res) => {
      console.log(res)
      setCompanyId(res.id)
      setAccounts(res.list)
    })
  }, [])
  return {
    companyId,
    accounts
  }
}

interface HeaderUserProps {
  revertColor?: boolean; // 反色模式，文字颜色改为白色，用于深色主题下
  useOnlyNewLayout: boolean; // 控制版本切换入口
}

export const User = (props: HeaderUserProps) => {
  const useNewLayout = getCookie(USE_NEW_LAYOUT_COOKIE)
  const [switchVisible] = useState(useNewLayout === N)
  const [userInfo, setUserInfo] = useState<any>({})
  const [isLogout, setIsLogout] = useState(false)
  const [avatarHref, setAvatarHref] = useState<string>('/account/accountInfo')
  const { accounts, companyId } = useManageAccounts()

  useEffect(() => {
    getLoginInfo().then((res: any) => {
      const data = res.data || {}
      setAvatarHref(data.isGeneral ? '/company/toCompanyInfo' : '/account/accountInfo')
      setUserInfo(data)
    })
  }, [])
  const onGetQrCode = async () => {
    return getWechatKanBanSenceQrCode().then((res: { qrCodeUrl: any }) => {
      return {
        qrCodeUrl: res.qrCodeUrl
      }
    })
  }

  const toggleLayout = useCallback(() => {
    setCookie(USE_NEW_LAYOUT_COOKIE, Y, NEW_LAYOUT_COOKIE_AGE)
    window.loggerAction.sendnpv({
      action: 'switch_new_layout_version'
    })
    location.reload()
  }, [])

  const logMeOut = async () => {
    setIsLogout(true)
    try {
      if (location.hostname.includes('fangzhentan')) {
        // 爬虫网站登出逻辑
        const res: any = await spiderLogout()
        if (parseInt(res.code) === 0) {
          setIsLogout(false)
          window.location.href = '/portal/login'
        }
      } else {
        const res = await logout()
        if (!res) {
          setIsLogout(false)
          window.location.href = '/'
        }
      }
    } catch (error) {
      setIsLogout(false)
    }
  }

  const switchAccount = (account: Account) => {
    if (companyId) {
      changeAccount({
        changeAccountId: account.id,
        masterAccountId: companyId
      }).then(({ url }: any) => {
        if (typeof url === 'string') {
          window.location.href = url
        }
      })
    }
  }

  const userList = (accounts || []).map(account => {
    return (
      <Menu.Item
        className={styles.account}
        onClick={() => switchAccount(account)}
        key={companyId}
        active={account.id === companyId}
      >
        【{account.cityName}】{account.companyName}.{account.userName}
      </Menu.Item>
    )
  })
  const accountMenu = <Menu>{userList}</Menu>

  const rootClass = clsx(styles.headerBar, {
    [styles.revert]: props.revertColor
  })

  return (
    <div className={rootClass}>
      {!props.useOnlyNewLayout && switchVisible && (
        <a
          className={styles.useNewLayout}
          href="javascript: void(0);"
          onClick={toggleLayout}
        >
          <i className="iconbroker-swap" />
          <span>体验新版</span>
        </a>
      )}
      <QRCodeDropdown
        slogan={'手机看数据 · 更快更简单'}
        onGetQrCode={onGetQrCode}
      >
        <a
          className={styles.useNewLayout}
          href="javascript: void(0);"
        >
          <span>手机端</span>
        </a>
      </QRCodeDropdown>
      <a href={avatarHref}>
        <img
          src={require('../assets/comm_head_sculpture.png')}
          alt=""
          className={styles.avatar}
        />
      </a>
      {
        accounts.length === 0
          ? <a className={styles.username} href={avatarHref}>
              <span>{userInfo?.trueName}</span>
            </a>
          : <Dropdown overlay={accountMenu} placement={'bottomRight'}>
              <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                <span>{userInfo?.trueName}</span> <CaretDownOutlined />
              </a>
            </Dropdown>
      }
      <span className={styles.divide}>|</span>
      <Button
        type={'link'}
        className={styles.logout}
        onClick={logMeOut}
        loading={isLogout}
      >
        退出
      </Button>
    </div>
  )
}

const hostName = location.hostname
const isStandaloneCompanyHouseList = location.pathname.endsWith('/solar/mix/companyhouse/list__hl')
const threenetsLogoUrl = '//pages.anjukestatic.com/fe/esf/img/e2baf935/log_threenets@2x.png'
let logoUrl = isStandaloneCompanyHouseList
  ? threenetsLogoUrl
  : '//pic4.58cdn.com.cn/nowater/fangfe/n_v24e579fe0ee494e7da2d78bf7c8a6ebae.png'
if (!isStandaloneCompanyHouseList && hostName.includes('jikejia')) {
  logoUrl =
    '//pic1.58cdn.com.cn/nowater/fangfe/n_v24d01bd7bfef14290b4515f58d6403062.png'
} else if (!isStandaloneCompanyHouseList && hostName.includes('yfyk')) {
  logoUrl =
    '//pic3.58cdn.com.cn/nowater/fangfe/n_v2ef85df0a6aac4c62a982e0aa607c7e24.png'
} else if (!isStandaloneCompanyHouseList && hostName.includes('fangzhentan')) {
  // 爬虫网站隐藏图标
  logoUrl =
    '//pic8.58cdn.com.cn/nowater/fangfe/n_v29304ab63b7494082acc00910c2934f79.png'
}

export interface HeaderProps {
  className?: string;
  useOnlyNewLayout: boolean; // 控制版本切换入口
}

const MetisHeader = (props: PropsWithChildren<HeaderProps>) => {
  return (
    <div className={props.className}>
      <div className={styles.container}>
        <div className={styles.ribbon} />
        <Layout.Header className={styles.header}>
          <div className={clsx(styles.inner, { [styles.standalone]: isStandaloneCompanyHouseList })}>
            <div>
              <img
                src={logoUrl}
                alt=""
                className={clsx(styles.logo, { [styles.threenetsLogo]: isStandaloneCompanyHouseList })}
              />
            </div>
            <User useOnlyNewLayout={props.useOnlyNewLayout}/>
          </div>
        </Layout.Header>
      </div>
    </div>
  )
}

export { MetisHeader }
